export function isFinancePath(path: string) {
  return path === '/admin/finance' || path.startsWith('/admin/finance/');
}
// Fixed for the lifetime of the document. SPA navigation cannot unload already
// running third-party scripts, so Finance requires a clean document first.
export const isFinanceDocument =
  typeof window !== 'undefined' && isFinancePath(window.location.pathname);
